<template>
  <div class="invoice-create-page main-content">
    <div class="page-header">
      <div class="row">
        <div class="col-lg-4 col-md-6 col-sm-12">
          <h3 class="page-title">{{ $tc('accounts.view_account') }}</h3>
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <router-link slot="item-title" to="/super-admin/dashboard">{{ $t('general.home') }}</router-link>
            </li>
            <li class="breadcrumb-item">
                <router-link slot="item-title" to="/super-admin/accounts">  {{ $tc('accounts.account',2) }}</router-link>
            </li>
            <li class="breadcrumb-item">
                <a  href="#/" slot="item-title" @click="viewAccountPage" >{{ $tc('accounts.view_account') }}</a>
            </li>
          </ol>
        </div>
        <div class="col-lg-8 col-md-6 col-sm-12 align-self-center" >
          <h3 class="text-center" v-if="viewAccount && viewAccount.name !=null">{{ viewAccount.name }}</h3>
        </div>
      </div>

    </div>
    <div class="row settings-container">
      <div class="col-lg-4 settings-sidebar-container">
        <ol class="settings-sidebar">
          <li v-for="(menuItem, index) in finalMenuItems" :key="index"  class='sub-menu settings-menu-item'>
            <a href='#' class="link-color py-2 position: relative;">
             <font-awesome-icon :icon="[menuItem.iconType, menuItem.icon]" class="setting-icon"/>
              <span class="ml-3">{{ $t(menuItem.title) }}</span>
              <div class="right-arrow-submenu">
                <font-awesome-icon icon="caret-down" class="setting-icon"/>
              </div>
            </a>
            <ul>
              <li v-for="(childItem, childIndex) in menuItem.children" :key="childIndex" class="settings-menu-item">
                <router-link :class="['link-color', {'active-setting': hasActiveUrl(childItem.link)}]" :to="childItem.link">
                  <font-awesome-icon :icon="[childItem.iconType, childItem.icon]" class="setting-icon"/>
                  <span class="ml-3">{{ $t(childItem.title) }}</span>
                </router-link>
              </li>
            </ul>
          </li>
        </ol>
        <ol class="settings-sidebar"  v-if="profileMenuShow">
          <li v-for="(profileMenuItem, profileMenuIndex) in profileMenuItems" :key="profileMenuIndex"  class='settings-menu-item'>
            <a href='#' class="link-color py-2 position: relative;" @click="profileMenuToggle(profileMenuIndex)">
             <font-awesome-icon :icon="[profileMenuItem.iconType, profileMenuItem.icon]" class="setting-icon"/>
              <span class="ml-3">{{ $t(profileMenuItem.title) }}</span>
              <div class="right-arrow-submenu">
                <font-awesome-icon icon="caret-down" class="setting-icon"/>
              </div>
            </a>
            <ul  :id="'profile-submenu-'+profileMenuIndex" style="display:none">
              <li v-for="(childItem, childIndex) in profileMenuItem.children" :key="childIndex" class="settings-menu-item">
                <router-link :class="['link-color', {'active-setting': hasActiveUrl(childItem.link)}]" :to="childItem.link">
                  <font-awesome-icon :icon="[childItem.iconType, childItem.icon]" class="setting-icon"/>
                  <span class="ml-3">{{ $t(childItem.title) }}</span>
                </router-link>
              </li>
            </ul>
          </li>
        </ol>

        <!-- <ol class="settings-sidebar" v-if="processMenuShow">
          <li v-for="(processMenuItem, processMenuIndex) in processMenuItems" :key="processMenuIndex"  class='settings-menu-item'>
            <a href='#' class="link-color py-2 position: relative;" @click="processMenuToggle(processMenuIndex)">
             <font-awesome-icon :icon="[processMenuItem.iconType, processMenuItem.icon]" class="setting-icon"/>
              <span class="ml-3">{{ $t(processMenuItem.title) }}</span>
              <div class="right-arrow-submenu">
                <font-awesome-icon icon="caret-down" class="setting-icon"/>
              </div>
            </a>
            <ul  :id="'process-submenu-'+processMenuIndex" style="display:none">
              <li v-for="(procesChildItem, processChildIndex) in processMenuItem.children" :key="processChildIndex" class="settings-menu-item">
                <router-link :class="['link-color', {'active-setting': hasActiveUrl(procesChildItem.link)}]" :to="procesChildItem.link">
                  <font-awesome-icon :icon="[procesChildItem.iconType, procesChildItem.icon]" class="setting-icon"/>
                  <span class="ml-3">{{ $t(procesChildItem.title) }}</span>
                </router-link>
              </li>
            </ul>
          </li>
        </ol> -->


      </div>
      <div class="col-lg-8">
        <transition
          name="fade"
          mode="out-in">
          <router-view/>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    return {
        id:null,
        userType:null,
        profileMenuShow:false,
        processMenuShow:false,
        finalMenuItems: [
          {
            title: 'general.basic_information',
            icon: 'info',
            iconType: 'fa',
            children:[
             {
                link: `/super-admin/accounts/${this.$route.params.id}/view/basic-info`,
                title: 'accounts.basic_info',
                icon: 'info-circle',
                iconType: 'fa'
              },
              {
                link: `/super-admin/accounts/${this.$route.params.id}/view/company-address`,
                title: 'accounts.company_address',
                icon: 'address-card',
                iconType: 'fa'
              },
              {
                link: `/super-admin/accounts/${this.$route.params.id}/view/billing-address`,
                title: 'accounts.billing_address',
                icon: 'address-card',
                iconType: 'fa'
              },
              {
                link:  `/super-admin/accounts/${this.$route.params.id}/view/shipping-address`,
                title: 'accounts.shipping_address',
                icon: 'address-book',
                iconType: 'fa'
              },
            ]
          },
        ],
        profileMenuItems:[
          {
            title: 'general.financial_profile',
            icon: 'money-bill-alt',
            iconType: 'fa',
            children:[
              {
              link:  `/super-admin/accounts/${this.$route.params.id}/view/business-status`,
              title: 'profile.menu_title.business_status',
              icon: 'building',
              iconType: 'fa'
              },
              {
              link: `/super-admin/accounts/${this.$route.params.id}/view/borrower-profile`,
              title: 'profile.menu_title.borrower_profile',
              icon: 'user-tie',
              iconType: 'fa'
            },
            {
              link: `/super-admin/accounts/${this.$route.params.id}/view/stakeholder`,
              title: 'profile.menu_title.stakeholder',
              icon: 'user-friends',
              iconType: 'fa'
            },
            {
              link: `/super-admin/accounts/${this.$route.params.id}/view/business_financial_institutions`,
              title: 'profile.menu_title.business_financial_institutions',
              icon: 'landmark',
              iconType: 'fa'
            },
            {
              link: `/super-admin/accounts/${this.$route.params.id}/view/financial_facilities`,
              title: 'profile.menu_title.financial_facilities',
              icon: 'exchange-alt',
              iconType: 'fa'
            },
            {
              link: `/super-admin/accounts/${this.$route.params.id}/view/rescheduling_restructuring`,
              title: 'profile.menu_title.writeOff_rescheduling_restructuring',
              icon: 'pencil-alt',
              iconType: 'fas'
            },
            {
              link: `/super-admin/accounts/${this.$route.params.id}/view/documents`,
              title: 'profile.menu_title.documents',
              icon: 'file-contract',
              iconType: 'fa'
            },
            ]
          }
        ],
        processMenuItems:[
          {
            title: 'general.process',
            icon: 'procedures',
            iconType: 'fa',
            children:[
              {
              link:  `/super-admin/accounts/${this.$route.params.id}/view/internal-process`,
              title: 'general.internal_process',
              icon: 'project-diagram',
              iconType: 'fa'
              },
              {
              link: `/super-admin/accounts/${this.$route.params.id}/view/customer-process`,
              title: 'general.customer_process',
              icon: 'chalkboard-teacher',
              iconType: 'fa'
            },
            {
              link: `/super-admin/accounts/${this.$route.params.id}/view/processs-documents`,
              title: 'general.documents',
              icon: 'file',
              iconType: 'fa'
            },

            ]
          }
        ]
    }
  },
  watch: {
    '$route.path' (newValue) {
      if (newValue ===  `/super-admin/accounts/${this.$route.params.id}/view`) {
        this.$router.push( `/super-admin/accounts/${this.$route.params.id}/view/basic-info`)
      }
    }
  },
  computed: {
    ...mapGetters('account', [
      'viewAccount'
    ]),
  },
  created () {
    this.fetchAccount();
    if (this.$route.path === `/super-admin/accounts/${this.$route.params.id}/view`) {
      this.$router.push( `/super-admin/accounts/${this.$route.params.id}/view/basic-info`)
    }

  },
  mounted(){
    $('.sub-menu ul').hide();
    $(".sub-menu a").click(function () {
      $(this).parent(".sub-menu").children("ul").slideToggle("100");
    });
    if(this.viewAccount && (this.viewAccount.account_type =='supplier' || this.viewAccount.account_type =='SUPPLIER')){
      this.profileMenuShow=true;
      this.processMenuShow=true;
      this.getBusinessData();

    }
    else{
      this.profileMenuShow=false;
      this.processMenuShow=false;
    }
  },
   destroyed(){
    this.unsetBusiness()
    this.unsetStakeholders()
    this.unsetFinancialFacilities()
    this.unsetProfileDocuments()
  },
  methods: {
    ...mapActions('account', [
      'fetchViewAccount'
    ]),
    ...mapActions('business', [
      'unsetBusiness',
      'fetchBusinessByUser'
    ]),
    ...mapActions('business', [
      'BusinessPermission',
      'falseBusinessPermission',
      'unsetBusiness',
      'fetchBusinessByUser'
    ]),
    ...mapActions('stakeholder', [
      'unsetStakeholders',
    ]),
     ...mapActions('financialFacility', [
      'unsetFinancialFacilities'
    ]),
    ...mapActions('documentType', [
      'unsetProfileDocuments'
    ]),
    hasActiveUrl (url) {
      return this.$route.path.indexOf(url) > -1
    },
    async fetchAccount(){
      let res=await this.fetchViewAccount(this.$route.params.id);
      if(res.data.account.account_type=='supplier'){
        this.profileMenuShow=true;
        this.processMenuShow=true;
      };
    },
    viewAccountPage(){
      this.$router.push(`/super-admin/accounts/${this.$route.params.id}/view`)
    },
    profileMenuToggle(id){
      $("#"+"profile-submenu-"+id).slideToggle("100");
    },
    processMenuToggle(id){
      $("#"+"process-submenu-"+id).slideToggle("100");
    },
    async getBusinessData(){
      let formData = {
        user_id: this.$route.params.id,
      }
       let  response = await this.fetchBusinessByUser(formData)
    }
  }
}
</script>
